import { render, staticRenderFns } from "./OutingDetailNeedsMeal.vue?vue&type=template&id=5b001df6&lang=pug"
import script from "./OutingDetailNeedsMeal.vue?vue&type=script&lang=ts"
export * from "./OutingDetailNeedsMeal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports